const ActionTypes = {
    ACCESS_TOKEN_REQUEST: "ACCESS_TOKEN_REQUEST",
    ACCESS_TOKEN_SUCCESS: "ACCESS_TOKEN_SUCCESS",
    ACCESS_TOKEN_FAILURE: "ACCESS_TOKEN_FAILURE",

    RECEIVE_OTP_TOKEN: "RECEIVE_OTP_TOKEN",

    RESEND_OTP_REQUEST: "RESEND_OTP_REQUEST",
    RESEND_OTP_SUCCESS: "RESEND_OTP_SUCCESS",
    RESEND_OTP_FAILURE: "RESEND_OTP_FAILURE",

    VERIFY_OTP_REQUEST: "VERIFY_OTP_REQUEST",
    VERIFY_OTP_SUCCESS: "VERIFY_OTP_SUCCESS",
    VERIFY_OTP_FAILURE: "VERIFY_OTP_FAILURE",

    FETCH_USER_REQUEST: "FETCH_USER_REQUEST",
    FETCH_USER_SUCCESS: "FETCH_USER_SUCCESS",
    FETCH_USER_FAILURE: "FETCH_USER_FAILURE",
    
    REFRESH_ACCESS_TOKEN_REQUEST: "REFRESH_ACCESS_TOKEN_REQUEST",
    REFRESH_ACCESS_TOKEN_SUCCESS: "REFRESH_ACCESS_TOKEN_SUCCESS",
    REFRESH_ACCESS_TOKEN_FAILURE: "REFRESH_ACCESS_TOKEN_FAILURE",

    FETCH_MENU_REQUEST: "FETCH_MENU_REQUEST",
    FETCH_MENU_SUCCESS: "FETCH_MENU_SUCCESS",
    FETCH_MENU_FAILURE: "FETCH_MENU_FAILURE",

    FETCH_DATA_COUNT_REQUEST: "FETCH_DATA_COUNT_REQUEST",
    FETCH_DATA_COUNT_SUCCESS: "FETCH_DATA_COUNT_SUCCESS",
    FETCH_DATA_COUNT_FAILURE: "FETCH_DATA_COUNT_FAILURE",

    FETCH_DATA_FOLDER_REQUEST: "FETCH_DATA_FOLDER_REQUEST",
    FETCH_DATA_FOLDER_SUCCESS: "FETCH_DATA_FOLDER_SUCCESS",
    FETCH_DATA_FOLDER_FAILURE: "FETCH_DATA_FOLDER_FAILURE",

    CLEAR_DATA_FOLDER: "CLEAR_DATA_FOLDER",
    CLEAR_DETAIL_SEARCH: "CLEAR_DETAIL_SEARCH",

    FETCH_SEARCH_REQUEST: 'FETCH SEARCH REQUEST',
    FETCH_SEARCH_SUCCESS: 'FETCH SEARCH SUCCESS',
    FETCH_SEARCH_FAILURE: 'FETCH SEARCH FAILURE',

    FETCH_DETAIL_SEARCH_REQUEST: 'FETCH_DETAIL_SEARCH_REQUEST',
    FETCH_DETAIL_SEARCH_SUCCESS: 'FETCH_DETAIL_SEARCH_SUCCESS',
    FETCH_DETAIL_SEARCH_FAILURE: 'FETCH_DETAIL_SEARCH_FAILURE',

    FETCH_DETAIL_SEARCH_COUNT_REQUEST: 'FETCH_DETAIL_SEARCH_COUNT_REQUEST',
    FETCH_DETAIL_SEARCH_COUNT_SUCCESS: 'FETCH_DETAIL_SEARCH_COUNT_SUCCESS',
    FETCH_DETAIL_SEARCH_COUNT_FAILURE: 'FETCH_DETAIL_SEARCH_COUNT_FAILURE',
    
    FETCH_DATA_TYPE_REQUEST: 'FETCH_DATA_TYPE_REQUEST',
    FETCH_DATA_TYPE_SUCCESS: 'FETCH_DATA_TYPE_SUCCESS',
    FETCH_DATA_TYPE_FAILURE: 'FETCH_DATA_TYPE_FAILURE',
    // Document Registration
    REGISTER_DOCUMENT_REQUEST: 'REGISTER_DOCUMENT_REQUEST',
    REGISTER_DOCUMENT_SUCCESS: 'REGISTER_DOCUMENT_SUCCESS',
    REGISTER_DOCUMENT_FAILURE: 'REGISTER_DOCUMENT_FAILURE',
    
    // Pattern Selection
    SET_CURRENT_PATTERN: 'SET_CURRENT_PATTERN',
    
    // Form Actions
    CLEAR_FORM_DATA: 'CLEAR_FORM_DATA',

    TRIGGER_DATA_FOLDER_RELOAD: 'TRIGGER_DATA_FOLDER_RELOAD',

    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'LOGOUT_FAILURE',

    FETCH_SYSTEM_INFO_REQUEST: 'FETCH_SYSTEM_INFO_REQUEST',
    FETCH_SYSTEM_INFO_SUCCESS: 'FETCH_SYSTEM_INFO_SUCCESS',
    FETCH_SYSTEM_INFO_FAILURE: 'FETCH_SYSTEM_INFO_FAILURE',

    FETCH_WHAT_NEW_REQUEST: 'FETCH_WHAT_NEW_REQUEST',
    FETCH_WHAT_NEW_SUCCESS: 'FETCH_WHAT_NEW_SUCCESS',
    FETCH_WHAT_NEW_FAILURE: 'FETCH_WHAT_NEW_FAILURE',
};

export default ActionTypes;
